class FeedbacksAPI {
	getFeedbackCategories = async () => {
		const response = await fetch(`${process.env.REACT_APP_API}/feedbacks/categories`, {
			method: 'GET',
			mode: 'cors',
			headers: {
				'Content-Type': 'application/json',
			},
		})
		return response.json()
	}

	sendFeedback = async data => {
		const response = await fetch(`${process.env.REACT_APP_API}/feedbacks`, {
			body: JSON.stringify(data),
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
			},
		})
		return response.json()
	}

	getAllSendFeedbacks = async id => {
		const response = await fetch(`${process.env.REACT_APP_API}/feedbacks/${id}`, {
			method: 'GET',
			headers: {
				'Content-Type': 'application/json',
			},
		})

		return response.json()
	}

	getCommentsByTarget = async id => {
		const response = await fetch(`${process.env.REACT_APP_API}/feedbacks/target/comments/${id}`, {
			method: 'GET',
			headers: {
				'Content-Type': 'application/json',
			},
		})

		return response.json()
	}

	getFeedbacksReceived = async id => {
		const response = await fetch(`${process.env.REACT_APP_API}/feedbacks/received/${id}`, {
			method: 'GET',
			headers: {
				'Content-Type': 'application/json',
			},
		})
		return response.json()
	}

	getAllEmployeeWithFeedbacksSender = async id => {
		const response = await fetch(`${process.env.REACT_APP_API}/feedbacks/company/sender/${id}`, {
			method: 'GET',
			headers: { 'Content-Type': 'application/json' },
		})

		return response.json()
	}

	getAllEmployeeWithFeedbacksReceiver = async id => {
		const response = await fetch(`${process.env.REACT_APP_API}/feedbacks/company/receiver/${id}`, {
			method: 'GET',
			headers: { 'Content-Type': 'application/json' },
		})

		return response.json()
	}
}
export default new FeedbacksAPI()
